
import { useNavigate } from "react-router-dom";
import { isSSR } from "@/lib/isSSR";

export function useDealerUtils() {
  // Use navigate only in client-side rendering
  const navigate = !isSSR() ? useNavigate() : null;

  const formatCityName = (city?: string) => {
    if (!city) return '';
    return city
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Questa è la funzione chiave che stiamo modificando
  const createDealerCanonicalPath = (dealerId: string, dealerCity?: string, urlCity?: string) => {
    // Assicuriamoci sempre di avere una città nell'URL
    // Se la città del dealer non è disponibile, usiamo quella dell'URL o come fallback "roma"
    const citySlug = dealerCity && dealerCity.trim() !== ''
      ? dealerCity.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-')
      : urlCity || 'roma';
    
    return `/compro-oro/${citySlug}/${dealerId}`;
  };

  const createCitySlug = (city: string) => {
    return city.toLowerCase().replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
  };

  const handleGoBack = (city?: string) => {
    if (isSSR()) {
      // No-op in server-side rendering
      return;
    }
    
    if (city) {
      navigate!(`/compro-oro/${city}`);
    } else {
      navigate!("/compro-oro");
    }
  };

  const convertMetalFormat = (metal: "ORO" | "ARGENTO"): "gold" | "silver" => {
    return metal === "ORO" ? "gold" : "silver";
  };

  const formatCityNameFromSlug = (citySlug: string) => {
    return formatCityName(citySlug);
  };

  return {
    formatCityName,
    formatCityNameFromSlug,
    createDealerCanonicalPath,
    createCitySlug,
    handleGoBack,
    convertMetalFormat
  };
}
